var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isFullscreen,
          expression: "isFullscreen",
        },
      ],
      ref: "fullScreenWrapper",
      staticClass: "fullscreen-video",
      class: { full: _vm.isFullscreen },
      style: { backgroundColor: _vm.bgColor, height: _vm.remainScreenHeight },
    },
    [
      _c("Icon", {
        staticClass: "icon-close-info-white",
        on: { click: _vm.exitFullScreen },
      }),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.isFullscreen
        ? _c("i-video", {
            ref: "video",
            class: _vm.fit,
            attrs: {
              url: _vm.url,
              muted: _vm.isMuted,
              volume: _vm.volume,
              paused: _vm.isPaused,
              "current-time": _vm.time,
              loop: _vm.loop,
              controls: _vm.controls,
              autoplay: _vm.autoplay,
              "custom-listeners": {
                dblclick: _vm.exitFullScreen,
                click: _vm.onClick,
              },
            },
            on: {
              ended: function ($event) {
                return _vm.$emit("ended", $event)
              },
              seeking: function ($event) {
                return _vm.handleChange({ time: $event.currentTime })
              },
              "volume-change": function ($event) {
                return _vm.handleChange({ volume: $event.volume })
              },
              "toggle-muted": function ($event) {
                return _vm.handleChange({
                  isMuted: $event.muted,
                  volume: $event.volume,
                })
              },
              "toggle-pause": function ($event) {
                return _vm.handleChange({
                  isPaused: $event.paused,
                  time: $event.currentTime,
                })
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }